// Import controller interfaces
import {
    IEndorsementPolicyEntityController
} from '../Interfaces/ControllerInterfacesBarrel';
import ApiController from './ApiController';
// Import api models.
import {
    BuildingRequestCommercial,
    BuildingRequestCommercialExisting,
    ErrorMessage,
    MortgageeRequest,
} from '@app/models/api';
// Import enumerations.
import {
    EndorsementEntityType,
} from '@app/enumerations';

export default class ProductionEndorsementPolicyEntityController extends ApiController implements IEndorsementPolicyEntityController {
    private readonly controllerUrl: string = 'v2/endorsementPolicyEntity';

    public constructor() {
        super();
    }

    public async addMortgageeForEndorsement(endorsementId: number, mortgagee: MortgageeRequest): Promise<string> {
        let url: string = `${this.controllerUrl}/mortgagee/${endorsementId}`;

        try {
            let response: Response = await super.makePostCall(url, mortgagee, undefined, undefined, true);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = `Could not add mortgagee.`;
            }
            throw error;
        }
    }

    public async updateMortgageeForEndorsement(endorsementId: number, mortgageeGuid: string, mortgagee: MortgageeRequest): Promise<number> {
        let url: string = `${this.controllerUrl}/mortgagee/${endorsementId}/${mortgageeGuid}`;

        try {
            let response: Response = await super.makePutCall(url, mortgagee, undefined, undefined, true);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = `Could not update mortgagee.`;
            }
            throw error;
        }
    }

    public async addBuildingForEndorsement(endorsementId: number, building: BuildingRequestCommercial): Promise<string> {
        let url: string = `${this.controllerUrl}/building/${endorsementId}`;

        try {
            let response: Response = await super.makePostCall(url, building, undefined, undefined, true);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = `Could not add building.`;
            }
            throw error;
        }
    }

    public async updateBuildingForEndorsement(endorsementId: number, building: BuildingRequestCommercialExisting): Promise<number> {
        let url: string = `${this.controllerUrl}/building/${endorsementId}`;

        try {
            let response: Response = await super.makePutCall(url, building, undefined, undefined, true);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = `Could not update building.`;
            }
            throw error;
        }
    }

    public async removeEntityForEndorsement(endorsementId: number, entityType: EndorsementEntityType, entityId: string): Promise<boolean> {
        let url: string = `${this.controllerUrl}/${endorsementId}`;

        let data = {
            'systemEntityType': entityType,
            'systemEntityId': entityId,
        };

        try {
            let response: Response = await super.makeDeleteCall(url, undefined, undefined, true, data);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = `Could not remove entity ${entityType} with id ${entityId}.`;
            }
            throw error;
        }
    }

    public async reinstateEntityForEndorsement(endorsementId: number, entityType: EndorsementEntityType, entityId: string): Promise<boolean> {
        let url: string = `${this.controllerUrl}/Reinstate/${endorsementId}`;

        let data = {
            'systemEntityType': entityType,
            'systemEntityId': entityId,
        };

        try {
            let response: Response = await super.makePostCall(url, data);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = `Could not resinstate entity ${entityType} with id ${entityId}.`;
            }
            throw error;
        }
    }
}